var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.599,
    height: 18.599,
    viewBox: "0 0 21.599 18.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "key",
    d: "M7.5,21.8a6.3,6.3,0,1,1,3.853-11.284l7.081-7.081a.8.8,0,0,1,1.131,0l3,3a.8.8,0,0,1,0,1.131l-3.5,3.5a.8.8,0,0,1-1.131,0L15.5,8.631l-3.014,3.014A6.3,6.3,0,0,1,7.5,21.8Zm0-11a4.7,4.7,0,1,0,3.345,1.4l-.021-.021A4.685,4.685,0,0,0,7.5,10.8Zm9.131-3.3L18.5,9.369,20.869,7,19,5.131Z",
    transform: "translate(-1.201 -3.2)",
    fill: "#00246A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.5cf4997ce79773e959131180d937831a.svg";
export { ForwardRef as ReactComponent };